module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f40501ed87782097b1a4eec8747eb84a.png";